import { ColorDynamic } from '@superdispatch/ui';
import { createSvgIcon } from 'shared/icons/IconUtils';

export const PdfIcon = createSvgIcon(
  'PdfIcon',
  <path
    d="M13.3333 1.33334H5.33333C4.6 1.33334 4 1.93334 4 2.66668V10.6667C4 11.4 4.6 12 5.33333 12H13.3333C14.0667 12 14.6667 11.4 14.6667 10.6667V2.66668C14.6667 1.93334 14.0667 1.33334 13.3333 1.33334ZM7.66667 6.33334C7.66667 6.88668 7.22 7.33334 6.66667 7.33334H6V8.66668H5V4.66668H6.66667C7.22 4.66668 7.66667 5.11334 7.66667 5.66668V6.33334ZM11 7.66668C11 8.22001 10.5533 8.66668 10 8.66668H8.33333V4.66668H10C10.5533 4.66668 11 5.11334 11 5.66668V7.66668ZM13.6667 5.66668H12.6667V6.33334H13.6667V7.33334H12.6667V8.66668H11.6667V4.66668H13.6667V5.66668ZM6 6.33334H6.66667V5.66668H6V6.33334ZM2.66667 4.00001H1.33333V13.3333C1.33333 14.0667 1.93333 14.6667 2.66667 14.6667H12V13.3333H2.66667V4.00001ZM9.33333 7.66668H10V5.66668H9.33333V7.66668Z"
    fill={ColorDynamic.Dark300}
  />,

  { viewBox: '0 0 16 16', style: { width: '16px', height: '16px' } },
);
